import type { ReactElement, ReactNode } from "react";
import React, { useState } from "react";

interface TabPanelProps {
  label: ReactNode;
  children: ReactNode;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children }) => {
  return <>{children}</>;
};

interface TabsProps {
  children: ReactElement<TabPanelProps>[];
}

export const Tabs: React.FC<TabsProps> = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleTabClick = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div className="w-full">
      {/* Navigation bar */}
      <div className="relative flex justify-start border-b border-gray-300 h-full">
        {/* Tabs container */}
        <ul className="flex">
          {children.map((child, index) => (
            <li className="w-16" key={index}>
              <button
                className={`w-full items-center flex flex-col py-2 text-center font-medium transition-colors ${
                  activeIndex === index ? "text-blue-500" : "text-gray-500"
                }`}
                onClick={() => handleTabClick(index)}
              >
                {child.props.label}
              </button>
            </li>
          ))}
        </ul>
        {/* Active tab underline */}
        <div
          className="absolute bottom-0 h-1 bg-blue-500 transition-transform duration-300"
          style={{
            width: `calc(4rem)`, // Match button width (e.g., px-6 -> 6rem)
            transform: `translateX(${activeIndex * 4}rem)`,
          }}
        />
      </div>
      {/* Content */}
      <div className="relative overflow-hidden">
        {children.map((child, index) => (
          <div
            key={index}
            className={`transition-opacity duration-300 ease-in-out ${
              activeIndex === index ? "opacity-100" : "opacity-0"
            } ${activeIndex === index ? "block" : "hidden"}`}
          >
            {child.props.children}
          </div>
        ))}
      </div>
    </div>
  );
};
